import { COMPANY_COMMUNITY_RELATION_TYPE } from 'constants/company';

export const COMMUNITIES_AVATAR_SIZE = 30;
export const COMMUNITIES_PAGE_SIZE = 5;
export const COMMUNITIES_INDENT_SIZE = 35;

export const COMMUNITIES_TABLE_TITLE = {
  [COMPANY_COMMUNITY_RELATION_TYPE.COMMUNITY]: 'My Communities',
  [COMPANY_COMMUNITY_RELATION_TYPE.COMPETITOR]: 'Competitors',
};

export const COMMUNITIES_TABLE_SEARCH_PLACEHOLDER = {
  [COMPANY_COMMUNITY_RELATION_TYPE.COMMUNITY]: 'Search communities',
  [COMPANY_COMMUNITY_RELATION_TYPE.COMPETITOR]: 'Search competitor communities',
};

export const COMMUNITIES_TABLE_FIRST_COLUMN_TITLE = {
  [COMPANY_COMMUNITY_RELATION_TYPE.COMMUNITY]: 'COMMUNITY NAME',
  [COMPANY_COMMUNITY_RELATION_TYPE.COMPETITOR]: 'COMPETITOR COMMUNITY NAME',
};
